import { pm2ConfigStore } from "@pm2/store";
import { useLocation } from "@provider/navigation";

import * as styles from "./atom.skip-link.styles";

export function SkipLink(): React.JSX.Element {
  const baseUrl = pm2ConfigStore.useSelector((state) => state.baseUrl);
  const location = useLocation();

  return (
    <a
      className={styles.skipLink}
      href={`${baseUrl}${location.pathname}${location.search}#main`}
    >
      Skip til indhold
    </a>
  );
}
